import { tv } from 'tailwind-variants'

export const footerVariants = tv({
  slots: {
    container: 'text-mili mt-deca italic'
  },
  variants: {
    source: {
      PRODUCT: { container: 'text-secondary-xlight' },
      CLIENT: { container: 'text-secondary-medium' }
    },
    sourceUrl: {
      true: {
        container: 'cursor-pointer hover:text-primary-medium'
      }
    }
  }
})
